import { render } from "./PayMethod.vue?vue&type=template&id=5f6bb4e8&scoped=true"
import script from "./PayMethod.vue?vue&type=script&lang=js"
export * from "./PayMethod.vue?vue&type=script&lang=js"

import "./PayMethod.vue?vue&type=style&index=0&id=5f6bb4e8&lang=scss&scoped=true"

import exportComponent from "/var/www/html/OrderUser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6bb4e8"]])

export default __exports__